import './transactions-search.css'
import * as React from 'react'
import SearchForm from '../../components/search-form/search-form'

/**
 * Transactions Search Component.
 * Represents the transaction search page.
 *
 * @returns {React.ReactElement} - Transactions Search Component.
 */
const TransactionsSearch = () => {
  return <SearchForm />
}

export default TransactionsSearch
